import restClient from "./BackendRestClient";

export function getParcelPublicByTrackingId(searchQuery) {
    const query = searchQuery ? searchQuery.trim() : "";
    return restClient.get(["parcel", "tracking"].join("/"), {
        params: {trackingId: query}
    })
        .then(res => res)
}
